import styled from 'styled-components';

export const StyledComparisonTableWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  margin-top: 0.5rem;

  .ant-table {
    background: transparent;
  }

  .ant-table-cell {
    font-size: 0.781rem;
    white-space: nowrap;
  }

  .ant-table-content {
    scrollbar-width: thin;
    scrollbar-color: var(--card-border-color) transparent;

    &::-webkit-scrollbar {
      height: 0.25rem;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--card-border-color);
      border-radius: 0.25rem;
    }
  }
`;

export const StyledComparisonTableTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: rgb(138, 144, 153);
  margin-bottom: 0.375rem;
`;

export const StyledComparisonTableScroll = styled.div`
  overflow-x: auto;
`;

export const StyledComparisonTableLink = styled.a<{ $primary?: string }>`
  &,
  &:is(:visited, :hover, :active, :focus) {
    color: ${({ $primary }) => $primary};
  }

  &:hover {
    text-decoration: underline;
  }
`;
